






import {
  Vue,
  Component,
  Watch,
} from "@/shared/vuepack";
import {
  AccountsSummary,
  Home,
  HsabAccountSelection,
  HsabNotionalDashboard,
  SamlError
} from "@/employee/route-names";
import { SessionObject, TokenResponse } from "@okta/okta-auth-js";
import { OktaAuth } from "@/shared/api/auth";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import * as datadog from "@/shared/datadog";
import {
  AuthType,
  LoginMethod,
} from "@/shared/types";
import { useHsabAccountsStore } from "@/employee/store/hsabAccounts";
import { useUserStore } from "@/shared/store/user";
import { useRootStore } from "@/shared/store/root";
import { useFeatureFlagStore } from "@/shared/store/featureFlag";

@Component({
  components: {
    GenericLoadingSpinner
  }
})
export default class OktaSso extends Vue {
  hsabAccountStore = useHsabAccountsStore();
  userStore = useUserStore();
  featureFlagStore = useFeatureFlagStore();
  rootStore = useRootStore();
  session = null;

  created () {
    if (this.userStore.loggedIn) {
      this.rootStore.resetState();
    }

    this.userStore.setActiveUserPing();
  }

  mounted () {
    this.getSession();
  }

  getSession ()  {
    OktaAuth().getSession()
        .then(session => {
          this.session = session;

          if (this.isValidSession(this.session)) {
            this.getToken();
          }
          else {
            this.handleInvalidSession();
          }
        })
        .catch(error => {
          this.handleError(error, "session.get");
        });
  }
  getToken () {
    OktaAuth().getWithoutPrompt()
        .then(response => {
          this.handleLogin(response);
        })
        .catch(error => {
          this.handleError(error, "token.getWithoutPrompt");
        });
  }

  handleLogin (response: TokenResponse) {
    OktaAuth().setTokens(response.tokens);
    this.userStore.setAuthType(AuthType.Okta);
    this.userStore.setLoginMethod(LoginMethod.Sso);
    this.userStore.login({ username: "" });
  }

  handleError (error: any, source: string) {
    let message = error.errorSummary
        ? `Error in Okta SSO [${source}]: ${error.errorSummary}`
        : `Error in Okta SSO [${source}]`;

    if (this.isValidSession(this.session)) {
      message += ` login: ${this.session.login} createdAt: ${this.session.createdAt}`;
    }

    datadog.log(message, { ...error, fullPath: this.$route.fullPath }, "error");
    this.$router.push({ name: SamlError });
  }

  handleInvalidSession () {
    datadog.log("Error in Okta SSO: Unable to get user session", { fullPath: this.$route.fullPath }, "error");
    this.$router.push({ name: SamlError });
  }

  isValidSession (session: SessionObject) {
    return (session && session.status !== "INACTIVE");
  }
}
